<div class="content w-100 d-block">
    <div class="col-12 navigation-cards">
        <h3>Andre ofte stillede spørgsmål</h3>
        <div class="row">
            <div class="col-md-6 col-lg-3 col-sm-6 h-100 mb-3" *ngFor="let card of navigationCards">
                <div>
                    <div class="navigation-cards-card">
                        <div class="col-12 h-100 d-table navigation-cards-card-text">
                            <div class="align-middle mt-4">
                                <h4>{{card.Title}}</h4>
                                <p class="mt-3">{{card.Description}}</p>
                                <a class="navigation-cards-cta"
                                    (click)="onNavigateToPageClick(card.Url)">Læs
                                    mere</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>